import React, { useEffect, useState, useRef } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import CSVReader from "react-csv-reader";
import moment from "moment";
import DatePicker from "react-datepicker";
import pt from "date-fns/locale/pt-BR";

import api from "assets/services/api";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import useAuth from "hooks/useAuth";
import Table from "components/Table/Table.js";
import CardFooter from "components/Card/CardFooter";

import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import AssistantRounded from "@material-ui/icons/AssistantRounded"
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";


import ModalAddSell from "components/ModalAddSell/ModalAddSell";
import ModalDeleteRealOrder from "components/ModalDeleteRealOrder/ModalDeleteRealOrder"
import ModalBoundSell from "components/ModalBoundSell/ModalBoundSell";
import ModalCreateNf from "components/ModalCreateNf/ModalCreateNf";
import ModalCreateNfParmesao from "components/ModalCreateNfParmesao/ModalCreateNfParmesao";
import ModalUpdateOrderHelp from "components/ModalUpdateOrderHelp/ModalUpdateOrderHelp.js";
import ModalNfeReconciliation from "components/ModalNfeReconciliation/ModalNfeReconciliation";
const styles = {
    margintp: {
        textAlign: "right",
        marginTop: "10px"
    },
    colorCard: {
        color: "#000",
        marginBottom: "-1em",
        fontSize: "14px",
        textAlign: "center"
    },
    marginFor: {
        minHeight: "12em",
        // marginTop: "-10px"
    },
    dropDown: {
        width: "80%",
        margin: '0 2em 0 2em'
    },
    contentComponent: {
        display: "flex",
        justifyContent: "center",
        textAlign: "center"
    },
    gridContainer: {
        justifyContent: "center"
    },
    zindex: {
        zIndex: "4 !important",
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px",
    }
};

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

export default function Help() {
    Date.prototype.withoutTime = function () {
        var d = new Date(this);
        d.setHours(0, 0, 0, 0);
        return d;
    };
    const classes2 = useStyles2();
    const classes = useStyles();
    const fileInputRef = useRef();
    const parseOptions = {
        dynamicTyping: true,
        skipEmptyLines: true,
        transformHeader: header => header.toLowerCase().replace(/\W/g, "_")
    };
    const parseOptionsHeader = {
        header: true,
        dynamicTyping: true,
        skipEmptyLines: true,
        transformHeader: header => header.toLowerCase().replace(/\W/g, "_")
    };

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [modalShow, setModalShow] = useState(false);
    const [modalShowCreateNf, setModalShowCreateNf] = useState(false);
    const [modalShowCreateNfParmesao, setModalShowCreateNfParmesao] = useState(false);
    const [modalShowReconciliation, setModalShowReconciliation] = useState(false);
    const [modalShowUpdate, setModalShowUpdate] = useState(false);
    const [modalShowDelete, setModalShowDelete] = useState(false);
    const [modalShowBound, setModalShowBound] = useState(false);
    const [index, setIndex] = useState({ id: 1 });
    const [modalImport, setModalImport] = useState(false);

    const [reports, setReports] = useState([]);
    const [sells, setSells] = useState([]);
    const { storageId, garlicType } = useAuth();
    const [loading, setLoading] = useState();

    const importModal = () => {
        setModalImport(true);
    }

    function callModal(index) {
        if (!modalShowUpdate) {
            importModal();
        }
        setIndex(index);
        setModalShowUpdate(true);
    }

    function callModalDelete(index) {
        if (!modalShowDelete) {
            importModal();
        }
        setIndex(index);
        setModalShowDelete(true);
    }

    function callModalBound(index) {
        if (!modalShowBound) {
            importModal();
        }
        setIndex(index);
        setModalShowBound(true)
    }

    function callModalShow() {
        if (!modalShow) {
            importModal();
        }
        setModalShow(true);
    }

    function callModalShowCreateNf() {
        if (!modalShowCreateNf) {
            importModal();
        }
        setModalShowCreateNf(true);
    }

    function callModalShowCreateNfParmesao() {
        if (!modalShowCreateNfParmesao) {
            importModal();
        }
        setModalShowCreateNfParmesao(true);
    }

    async function handleForceEnable(data, fileInfo) {
        try {
            const response = await api.put('/enable/' + storageId, {
                nf: data
            });

            alert('Inadimplentes atualizados foram: ' + response.data.count);
        } catch (error) {
            alert(error.response.data);
        }
    }

    const handleButtonClick = (e) => {
        e.preventDefault();
        if (fileInputRef.current) {
            fileInputRef.current.click(); // Dispara o clique no input
        } else {
            console.error("Ref para o CSVReader não está configurada.");
        }
    };

    async function handleCancelSeveralNf(data, fileInfo) {
        try {
            console.log(data)
            const nfs = data.flat();
            console.log(nfs)
            if (nfs[0] !== 'cancelar') {
                return alert(`Cabeçalho arquivo errado.`)
            } else {
                nfs.shift();
            }
            const response = await api.patch(`/sell/cancel/several`, {
                id_admin: storageId,
                sells: nfs
            });

            // console.log(response)
            alert(`${response.data.cancel_error ? response.data.cancel_error.join('\n') : ''}\n${response.data.cancel_success ? response.data.cancel_success.join('\n') : ''}`);
        } catch (error) {
            alert(error);
        }
    }

    async function handleForce(data, fileInfo) {

        for (let i = 0; i < data.length; i++) {
            const response = await api.post('/help/rio', {
                client: data[i].clientes,
                cnpj: data[i].cnpj,
                product: data[i].produtos,
                value: data[i].valor,
                sellsman: data[i].vendedor
            })
        }

    }
    const reportOrderNull = async () => {
        const response = await api.get(`/help/order/null/${storageId}?garlic=${garlicType}`);
        setReports(response.data);
    }

    async function conferenceNf(data, fileInfo) {
        setLoading(true);
        let aux = [];
        for (let i = 0; i < data.length; i++) {
            if (data[i].pedido !== null || data[i].item !== null) {
                const response = await api.post('/help/conference/nf/' + storageId, {
                    nf: data[i].pedido,
                    code: data[i].id
                })
                aux.push(response.data);
            }
        }
        setSells(aux);
        setLoading(false);
    }

    function getReports() {
        let teste = [];
        for (let i = 0; i < reports.length; i++) {
            teste[i] = [];

            teste[i].push(reports[i].order_controller);
            teste[i].push(reports[i].social_reason);
            teste[i].push(reports[i].cnpj);
            teste[i].push(reports[i].name);
            teste[i].push(reports[i].new_code);
            teste[i].push(reports[i].amount != 0 ? reports[i].amount : reports[i].weight)
            teste[i].push("R$ " + reports[i].price_of_product);

            teste[i].push(reports[i].batch)
            teste[i].push(
                <div className={classes2.tableActions}>
                    <Tooltip
                        id="tooltip-top"
                        title="Vincular venda"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                    >
                        <IconButton
                            aria-label="Edit"
                            className={classes2.tableActionButton}
                            onClick={() => callModalBound(reports[i])}

                        >
                            <AssistantRounded
                                className={
                                    classes2.tableActionButtonIcon + " " + classes2.edit5
                                }
                            />
                        </IconButton>

                    </Tooltip>
                    <Tooltip
                        id="tooltip-top-start"
                        title="Editar"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                    >
                        <IconButton
                            aria-label="Edit"
                            className={classes2.tableActionButton}
                            onClick={() => callModal(reports[i])}
                        >
                            <Edit
                                className={
                                    classes2.tableActionButtonIcon + " " + classes2.edit
                                }
                            />
                        </IconButton>
                    </Tooltip>
                    <Tooltip
                        id="tooltip-top-start"
                        title="Deletar"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                    >
                        <IconButton
                            aria-label="Close"
                            className={classes2.tableActionButton}
                            onClick={() => callModalDelete(reports[i])}
                        >
                            <Close
                                className={
                                    classes2.tableActionButtonIcon + " " + classes2.close
                                }
                            />
                        </IconButton>
                    </Tooltip>
                </div>
            )
        }
        return teste;
    }
    function getNf() {
        let teste = [];
        for (let i = 0; i < sells.length; i++) {
            teste[i] = [];
            teste[i].push(sells[i].nf)
            teste[i].push(sells[i].name)
            teste[i].push(sells[i].message);
        }
        return teste;
    }



    async function handleForcePreferences(data, fileInfo) {
        for (let i = 0; i < data.length; i++) {
            const response = await api.post('/help/rio/tabulation/' + storageId, {
                preference: data[i].preference,
                cnpj: data[i].cnpj,
            })
        }
    }
    async function handleForceUndefined(data, fileInfo) {
        for (let i = 0; i < data.length; i++) {
            const response = await api.put('/help/rio/client/change/undefined/' + storageId, {
                social_reason: data[i].cliente,
                cnpj: data[i].cnpj,
            })
        }
    }
    async function handleForceAdress(data, fileInfo) {
        for (let i = 0; i < data.length; i++) {
            const response = await api.put('/client/change/address', {
                cnpj: data[i].cnpj,
                public_place: data[i].logradouro,
                neighborhood: data[i].bairro,
                city: data[i].cidade,
                contact: data[i].telefone,
                email: data[i].email,
                cep: data[i].cep
            })
        }
    };
    const generateReeportNfAndProd = async () => {
        try {
            const response = await api.post(
                "/sell/report/nf/prod",
                {
                    id_admin: storageId,
                    dateInit: moment(startDate).format('YYYY-MM-DD'),
                    dateEnd: moment(endDate).format('YYYY-MM-DD'),
                },
                {
                    responseType: "blob", // <- vem aqui, não dentro do body
                    headers: {
                        Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    },
                }
            );

            // cria o blob do arquivo
            const blob = new Blob([response.data], { type: response.headers["content-type"] });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `Nf e produtos ${moment(startDate).format('DD/MM/YYYY')} - ${moment(endDate).format('DD/MM/YYYY')}.xlsx`;
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            alert("Erro ao gerar relatório:", error);
        }
    }
    return (
        <GridContainer>
            <GridItem xs={12} sm={6} md={8}>
                <Card>
                    <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
                        <Button onClick={reportOrderNull}>Pedidos sem vinculos</Button>
                    </CardHeader>
                    <CardBody className="d-flex justify-content-center">
                        <Table tableHeaderColor="danger"
                            tableHead={[
                                "Pedido", "Razão social", "CNPJ", "Produto", "Codigo", "Quantidade", "Valor", "lote", "Ações"
                            ]}
                            tableData={getReports()}></Table>
                    </CardBody>

                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={4}>
                <Card cardPadding>
                    <CardHeader className="d-flex justify-content-center" color="warning" stats icon center>
                        <div>
                            <div style={{ marginBottom: "2rem" }}>
                                <h4 style={{ color: 'black', fontWeight: "bold" }}>Conferir notas importadas</h4>
                            </div>
                            <div style={{ marginBottom: "1.2rem" }}>
                                <h5 style={{ color: 'black' }}>Conferir notas importadas</h5>
                            </div>
                            <CSVReader
                                cssClass="react-csv-input"
                                onFileLoaded={conferenceNf}
                                parserOptions={parseOptionsHeader}
                            />


                        </div>

                    </CardHeader>
                    <CardBody className="d-flex justify-content-center">
                        {loading ? "Carregando..." :
                            <Table tableHeaderColor="danger"
                                tableHead={[
                                    "Notas", "Produto", "Situação"
                                ]}
                                tableData={getNf()} />
                        }
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center">
                        <Button color="success" onClick={() => callModalShow()}>Adicionar venda administrador</Button>
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
                <Card className={classes.marginFor}>
                    <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
                        <h4 style={{ color: 'black', fontWeight: 'bold' }}>INADIMPLENTES</h4>
                    </CardHeader>
                    <CardBody className="d-flex justify-content-center">
                        <div className="container">
                            <h5>Escolher o CSV para importar inadimplentes</h5>
                            <CSVReader
                                cssClass="react-csv-input"
                                onFileLoaded={handleForceEnable}
                                parserOptions={parseOptionsHeader}
                            />
                        </div>
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
                <Card className={classes.marginFor}>
                    <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
                        <h4 style={{ color: 'black', fontWeight: 'bold' }}>CANCELAMENTO DE NOTAS</h4>
                    </CardHeader>
                    <CardBody className="d-flex justify-content-center">
                        <h5>Escolher CSV para cancelamento de Notas Fiscas</h5>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center">
                        <div>
                            <CSVReader
                                cssClass="hiddenFileInputSeveralNf"
                                onFileLoaded={handleCancelSeveralNf}
                                parserOptions={parseOptions}
                                inputStyle={{ display: "none" }}
                                inputRef={fileInputRef} // Conecte a ref ao input
                            />
                            <button onClick={handleButtonClick}>Carregar Arquivo</button>
                        </div>
                    </CardFooter>
                </Card>

            </GridItem>
            {/*
                storageId === 3 && garlicType !== true ?
                    <GridItem xs={12} sm={6} md={3}>
                        <Card>
                            <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
                                <p style={{ color: 'black' }}>Criar nota de devolução Parmesão</p>
                            </CardHeader>
                            <CardBody className="d-flex justify-content-center">
                            </CardBody>
                            <CardFooter className="d-flex justify-content-center">
                                <Button color="success" onClick={() => callModalShowCreateNfParmesao(true)}>Criar nota</Button>
                            </CardFooter>
                        </Card>
                    </GridItem>
                    :
                    ""*/
            }
            {/*
                storageId === 3 && garlicType !== true ?
                    <GridItem xs={12} sm={6} md={3}>
                        <Card>
                            <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
                                <p style={{ color: 'black' }}>Criar nota de devolução</p>
                            </CardHeader>
                            <CardBody className="d-flex justify-content-center">
                            </CardBody>
                            <CardFooter className="d-flex justify-content-center">
                                <Button color="success" onClick={() => callModalShowCreateNf(true)}>Criar nota</Button>
                            </CardFooter>
                        </Card>
                    </GridItem>
                    :
                    ""
            */}
            <GridItem xs={12} sm={6} md={3}>
                <Card className={classes.marginFor}>
                    <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
                    </CardHeader>
                    <CardBody className="d-flex justify-content-center">
                        <div >
                            <h4 style={{ color: 'black', fontWeight: 'bold' }}>RELATORIO DE NOTAS E PRODUTOS</h4>
                            <h5>Escolher datas</h5>
                            <div className="d-flex justify-content-center">
                                <DatePicker
                                    className={classes.marginDate + " " + classes.zindex}
                                    selected={startDate}
                                    onChange={(date) =>
                                        date ? setStartDate(date) : setStartDate(null)
                                    }
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="Digite ou clique aqui"
                                    disabledKeyboardNavigation
                                    locale={pt}
                                />
                            </div>
                            <div className="d-flex justify-content-center">
                                <DatePicker
                                    className={classes.marginDate + " " + classes.zindex}
                                    selected={endDate}
                                    onChange={(date) =>
                                        date ? setEndDate(date) : setEndDate(null)
                                    }
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="Digite ou clique aqui"
                                    disabledKeyboardNavigation
                                    locale={pt}
                                />
                            </div>
                        </div>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center">
                        <div>
                            <Button color="success" onClick={() => generateReeportNfAndProd()} >
                                Gerar relatorio
                            </Button>
                        </div>
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
                <Card className={classes.marginFor}>
                    <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
                        <h4 style={{ color: 'black', fontWeight: 'bold' }}>CONCILIAÇÃO NF RETORNO</h4>
                    </CardHeader>
                    <CardBody className="d-flex justify-content-center">
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center">
                        <Button color="success" onClick={() => setModalShowReconciliation(true)}>Conciliação NF retorno</Button>
                    </CardFooter>
                </Card>
            </GridItem>
            {modalImport && modalShow && (
                <ModalAddSell key={String("add_" + storageId)} show={modalShow} help={true} onHide={() => setModalShow(false)} />
            )}
            {modalImport && modalShowCreateNf && (
                <ModalCreateNf key={String("nf_" + storageId)} show={modalShowCreateNf} onHide={() => setModalShowCreateNf(false)} />
            )}
            {modalImport && modalShowCreateNfParmesao && (
                <ModalCreateNfParmesao key={String("nf_" + (storageId + 1))} show={modalShowCreateNfParmesao} onHide={() => setModalShowCreateNfParmesao(false)} />
            )}
            {modalImport && modalShowBound && (
                <ModalBoundSell key={String("bd_" + index.id)} props={index} show={modalShowBound} help={true} onHide={() => setModalShowBound(false)} />
            )}
            {modalImport && modalShowUpdate && (
                <ModalUpdateOrderHelp key={"modal_upt" + (storageId + 1)} props={index} show={modalShowUpdate} onHide={() => setModalShowUpdate(false)} loadOrder={reportOrderNull} />
            )}
            {modalImport && modalShowDelete && (
                <ModalDeleteRealOrder key={String("Dlt_" + index.id)} props={index} show={modalShowDelete} onHide={() => setModalShowDelete(false)} />
            )}
            <ModalNfeReconciliation show={modalShowReconciliation} onHide={() => setModalShowReconciliation(false)} />
        </GridContainer>
    )
}